import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(default)/category/Category.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(default)/category/components/WRHeader/WRHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/category/video/components/VideoLazyArticles/VideoLazyArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/category/video/components/VideoLazyArticles/VideoPremiumFreemiumLazyArticles.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Analytics/Facebook/FBPixelScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Analytics/Google/GAScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/ArticleBanner/ArticleBanner.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/FreemiumOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/LoggedInOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/NotLoggedInOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Only/PremiumOnly.tsx");
